import "bootstrap/dist/js/bootstrap.bundle.min.js";
import viMessages from "./messages/vi.json"
import enMessages from "./messages/en.json"
import { initAnimation } from './animation'
import Swiper from "swiper/bundle";
import { Pagination } from "swiper/modules";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const LANG_KEY = 'lang'

const messagesTrans = {
    vi: viMessages,
    en: enMessages
}

const getCurrentLang = () => {
    const lang = localStorage.getItem(LANG_KEY) ?? 'vi';

    return lang
}

const currentLang = getCurrentLang()

const getMessage = (key = '') => {
    const messages = messagesTrans[currentLang]

    const keys = key.split(".")
    let message = messages[keys[0]] ?? ''

    try {
        for (let i = 1; i < keys.length; i++) {
            message = message[keys[i]]
        }
    } catch (error) {
        message = ''
    }

    return message
}

const initTranslation = () => {
    const listElem = document.querySelectorAll("[data-translation]")

    listElem.forEach(elem => {
        const key = elem.dataset.translation

        elem.innerHTML = getMessage(key)
    })
}

const initHamburgerMenu = () => {
    const btn = document.querySelector(".hamburger-menu");

    if (!btn) return;

    const header = document.querySelector(".header");
    const mainMenu = document.querySelector(".header-nav")


    btn.addEventListener("click", (e) => {
        e.preventDefault();

        if (btn.classList.contains("menu-on")) {
            // close
            btn.classList.remove("menu-on");

            document.body.style.overflow = "";
            header.classList.remove("menu-open");

            // setTimeout(() => {
                mainMenu.classList.remove("show")
            // }, 410);

        } else {
            btn.classList.add("menu-on");

            document.body.style.overflow = "hidden";
            mainMenu.classList.add("show")
            header.classList.add("menu-open");

        }
    });

    const btns = document.querySelectorAll(".header a")

    if (window.innerWidth < 1200) {
        btns.forEach(bb => {
            bb.addEventListener("click", function () {
                btn.click()
            })
        })
    }

};

const initChangeLang = () => {
    const btns = document.querySelectorAll(".btn-lang")
    // const currentLang = localStorage.getItem(LANG_KEY) ?? "vi"

    btns.forEach(btn => {
        const lang = btn.dataset.lang

        if (lang == currentLang) {
            btn.classList.add("active")
        }

        // btn.addEventListener("click", function () {
        //     localStorage.setItem(LANG_KEY, lang);

        //     location.reload()
        // })
    })

    // const btnLang = document.querySelector(".language-panel-btn")
    // btnLang.addEventListener("click", function (e) {
    //     e.preventDefault()

    //     const lang = currentLang == 'vi' ? 'en' : 'vi'

    //     localStorage.setItem(LANG_KEY, lang);

    //     // location.reload()
    //     let newUrl = location.href
    //     newUrl = newUrl.replace(location.hash, "")

    //     window.location.href = newUrl
    // })

    if (currentLang == 'vi') {
        document.body.classList.add("vnpage")
    }
}

const changeTitlePage = () => {
    const translationTitle = document.querySelector("#translationTitle")

    if (!translationTitle)
        return

    const title = getMessage(translationTitle.value) ?? ""

    document.title = title + " | Viglacera-Exim"
}

const initScrollToTop = () => {
    const backToTopElem = document.querySelector(".back-to-top");
    const footerPhone = document.querySelector(".footer-phone");
    const header = document.querySelector(".header");

    if (!backToTopElem) return;

    let ticking = false;
    let lastKnownScrollPosition;

    function showBackToTop(scrollPos) {
        if(scrollPos > 300) {
            backToTopElem.classList.add("show")
            footerPhone.classList.add("show")
        } else {
            backToTopElem.classList.remove("show")
            footerPhone.classList.remove("show")
        }
    }

    function stickyHeader(scrollPos) {
        if (scrollPos > 0) {
            header.classList.add("sticky")
        } else {
            header.classList.remove("sticky")
        }
    }

    window.addEventListener("load", function() {
        showBackToTop(window.scrollY)
        stickyHeader(window.scrollY)
    })

    document.addEventListener('scroll', function(e) {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function() {
                showBackToTop(lastKnownScrollPosition)
                stickyHeader(window.scrollY)
                ticking = false
            });

            ticking = true
        }
    });

    backToTopElem.addEventListener("click", (e) => {
        e.preventDefault();

        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
};


/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
    - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
    - When each item animates to the left or right enough, it will loop back to the other side
    - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
    - The returned timeline will have the following methods added to it:
    - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
    - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
    - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
    - current() - returns the current index (if an animation is in-progress, it reflects the final index)
    - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
 */
    const horizontalLoop = (items, config) => {
        items = gsap.utils.toArray(items);
        config = config || {};
        let tl = gsap.timeline({
                repeat: config.repeat,
                paused: config.paused,
                defaults: { ease: "none" },
                onReverseComplete: () =>
                    tl.totalTime(tl.rawTime() + tl.duration() * 100),
            }),
            length = items.length,
            startX = items[0].offsetLeft,
            times = [],
            widths = [],
            xPercents = [],
            curIndex = 0,
            pixelsPerSecond = (config.speed || 1) * 100,
            snap =
                config.snap === false
                    ? (v) => v
                    : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
            totalWidth,
            curX,
            distanceToStart,
            distanceToLoop,
            item,
            i;
        gsap.set(items, {
            // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
            xPercent: (i, el) => {
                let w = (widths[i] = parseFloat(
                    gsap.getProperty(el, "width", "px")
                ));
                xPercents[i] = snap(
                    (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
                        gsap.getProperty(el, "xPercent")
                );
                return xPercents[i];
            },
        });
        gsap.set(items, { x: 0 });
        totalWidth =
            items[length - 1].offsetLeft +
            (xPercents[length - 1] / 100) * widths[length - 1] -
            startX +
            items[length - 1].offsetWidth *
                gsap.getProperty(items[length - 1], "scaleX") +
            (parseFloat(config.paddingRight) || 0);
        for (i = 0; i < length; i++) {
            item = items[i];
            curX = (xPercents[i] / 100) * widths[i];
            distanceToStart = item.offsetLeft + curX - startX;
            distanceToLoop =
                distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
            tl.to(
                item,
                {
                    xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
                    duration: distanceToLoop / pixelsPerSecond,
                },
                0
            )
                .fromTo(
                    item,
                    {
                        xPercent: snap(
                            ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
                        ),
                    },
                    {
                        xPercent: xPercents[i],
                        duration:
                            (curX - distanceToLoop + totalWidth - curX) /
                            pixelsPerSecond,
                        immediateRender: false,
                    },
                    distanceToLoop / pixelsPerSecond
                )
                .add("label" + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
        }
        function toIndex(index, vars) {
            vars = vars || {};
            Math.abs(index - curIndex) > length / 2 &&
                (index += index > curIndex ? -length : length); // always go in the shortest direction
            let newIndex = gsap.utils.wrap(0, length, index),
                time = times[newIndex];
            if (time > tl.time() !== index > curIndex) {
                // if we're wrapping the timeline's playhead, make the proper adjustments
                vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
                time += tl.duration() * (index > curIndex ? 1 : -1);
            }
            curIndex = newIndex;
            vars.overwrite = true;
            return tl.tweenTo(time, vars);
        }
        tl.next = (vars) => toIndex(curIndex + 1, vars);
        tl.previous = (vars) => toIndex(curIndex - 1, vars);
        tl.current = () => curIndex;
        tl.toIndex = (index, vars) => toIndex(index, vars);
        tl.times = times;
        if (config.reversed) {
            tl.vars.onReverseComplete();
            tl.reverse();
        }
        return tl;
    };
    
const initMarquee = () => {
    const highlightPanel = document.querySelector(".highlight-panel")

    if (!highlightPanel)
        return

    const i = 0
    const links = document.querySelectorAll(".highlight-panel__content-wrapper a")
    const marqueeTl = horizontalLoop(links, {
            repeat: -1,
            speed: 0.5,
            reversed: i ? true : false,
            paddingRight: parseFloat(
                gsap.getProperty(links[0], "marginRight", "px")
            ), // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
        });

    links.forEach((link) => {
        link.addEventListener("mouseenter", () =>
            gsap.to(marqueeTl, { timeScale: 0, overwrite: true })
        );
        link.addEventListener("mouseleave", () =>
            gsap.to(marqueeTl, { timeScale: i ? -1 : 1, overwrite: true })
        );
    });

    ScrollTrigger.create({
        trigger: highlightPanel,
        onEnterBack() {
            marqueeTl.play()
        },
        onLeave() {
            marqueeTl.pause()
        }
    })

}

const initHero = () => {
    const heroBlock = document.querySelector(".hero-block");

    if (!heroBlock) return;

    const sliderElem = heroBlock.querySelector("#heroSwiper");

    const swiper = new Swiper(sliderElem, {
        modules: [Pagination],
        loop: true,
        speed: 1000,
        parallax: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        effect: "fade",
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

const initAutoScrollAnchor = () => {
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (window.location.hash && isChrome) {
        setTimeout(function () {
            var hash = window.location.hash;
            window.location.hash = "";
            window.location.hash = hash;
        }, 300);
    }
}

window.addEventListener("resize", function () {
    document.body.style.overflow = ""
})

window.addEventListener("load", function () {
    const loadingPanel = document.querySelector(".loading")

    setTimeout(() => {
        loadingPanel.remove()
    }, 300);

    initAutoScrollAnchor()
})

document.addEventListener("DOMContentLoaded", () => {
    initTranslation()
    changeTitlePage()
    initHamburgerMenu()
    initChangeLang()
    initScrollToTop()

    initHero();
    initMarquee()
})

initAnimation()